import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Analytics Service
 * Dashboard analytics (charts/KPIs) and downloadable reports.
 * Filters: { from, to } as YYYY-MM-DD, plus optional cityId, partnerId, serviceTitle.
 */
const unwrap = (response) => {
  const body = response.data;
  if (!body || body.IsSuccess === false) {
    throw new Error((body && body.Message) || 'Request failed');
  }
  return body.Data;
};

const analyticsService = {
  getFilterOptions: async () => unwrap(await apiClient.post(API_ENDPOINTS.ANALYTICS.FILTERS, {})),
  getOverview: async (filters = {}) => unwrap(await apiClient.post(API_ENDPOINTS.ANALYTICS.OVERVIEW, filters)),
  getPartners: async (filters = {}) => unwrap(await apiClient.post(API_ENDPOINTS.ANALYTICS.PARTNERS, filters)),
  getPartnerReport: async (partnerId, filters = {}) =>
    unwrap(await apiClient.post(API_ENDPOINTS.ANALYTICS.PARTNER, { ...filters, partnerId })),
  getReport: async (type, filters = {}) =>
    unwrap(await apiClient.post(API_ENDPOINTS.ANALYTICS.REPORT, { ...filters, type })),
};

export default analyticsService;
